import type { CourseStatus } from '../../constants/contentAuthoringEnums';

const SESSION_KEY = 'course-translation-outcome';

export type CourseTranslationOutcomeType = 'ready' | 'failed' | 'partial';

/** Passed from translations page to courses list when a translation job finishes. */
export interface CourseTranslationOutcome {
  courseId: string;
  courseName: string;
  courseStatus: CourseStatus;
  languageLabel: string;
  outcome: CourseTranslationOutcomeType;
}

export function isCourseTranslationOutcome(value: unknown): value is CourseTranslationOutcome {
  if (!value || typeof value !== 'object') {
    return false;
  }
  const state = value as CourseTranslationOutcome;
  return (
    typeof state.courseId === 'string' &&
    state.courseId.trim().length > 0 &&
    typeof state.courseName === 'string' &&
    typeof state.courseStatus === 'string' &&
    typeof state.languageLabel === 'string' &&
    (state.outcome === 'partial' || state.languageLabel.trim().length > 0) &&
    (state.outcome === 'ready' || state.outcome === 'failed' || state.outcome === 'partial')
  );
}

export function persistCourseTranslationOutcome(state: CourseTranslationOutcome): void {
  try {
    sessionStorage.setItem(SESSION_KEY, JSON.stringify(state));
  } catch {
    /* sessionStorage may be unavailable */
  }
}

export function readCourseTranslationOutcome(): CourseTranslationOutcome | null {
  try {
    const raw = sessionStorage.getItem(SESSION_KEY);
    if (!raw) {
      return null;
    }
    const parsed: unknown = JSON.parse(raw);
    return isCourseTranslationOutcome(parsed) ? parsed : null;
  } catch {
    return null;
  }
}

export function clearCourseTranslationOutcome(): void {
  try {
    sessionStorage.removeItem(SESSION_KEY);
  } catch {
    /* sessionStorage may be unavailable */
  }
}
